<template>
  <div class="alphabet">
    <span :class="{ 'active' : !currentLetter}" @click="setAll">Alle</span>
    <span v-for="letter in alphabet" :key="letter" :class="{ 'active' : letter === currentLetter}" @click="setLetter(letter)">{{ letter }}</span>
  </div>
</template>

<script>
export default {
  name: 'Alphabet',
  data() {
    return {
      alphabet: ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'],
      currentLetter: this.letter,
    };
  },
  props: {
    letter: {
      type: String,
      default: '',
    }
  },
  methods: {
    setAll() {
      this.currentLetter = '';
    },
    setLetter(letter) {
      this.currentLetter = letter;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Alphabet.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Alphabet/Alphabet.vue